/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as DashboardUsersRouteImport } from './routes/_dashboard/users'
import { Route as DashboardSimulationsRouteImport } from './routes/_dashboard/simulations'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as DashboardPricingPolicyRouteImport } from './routes/_dashboard/pricing-policy'
import { Route as DashboardHistoryRouteImport } from './routes/_dashboard/history'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthCallbackRouteImport } from './routes/_auth/callback'
import { Route as DashboardSimulatorsIndexRouteImport } from './routes/_dashboard/simulators/index'
import { Route as DashboardProposalsIndexRouteImport } from './routes/_dashboard/proposals/index'
import { Route as DashboardProposalsIdRouteImport } from './routes/_dashboard/proposals/$id'
import { Route as DashboardAdminUtilitiesRouteImport } from './routes/_dashboard/admin/utilities'
import { Route as DashboardAdminUserActivityRouteImport } from './routes/_dashboard/admin/user-activity'
import { Route as DashboardAdminSimulationsRouteImport } from './routes/_dashboard/admin/simulations'
import { Route as DashboardAdminSimulationEventsRouteImport } from './routes/_dashboard/admin/simulation-events'
import { Route as DashboardAdminProposalsRouteImport } from './routes/_dashboard/admin/proposals'
import { Route as DashboardAdminPricingPolicyRouteImport } from './routes/_dashboard/admin/pricing-policy'
import { Route as DashboardAdminModelsRouteImport } from './routes/_dashboard/admin/models'
import { Route as DashboardAdminGroupsRouteImport } from './routes/_dashboard/admin/groups'
import { Route as DashboardAdminDocumentationRouteImport } from './routes/_dashboard/admin/documentation'
import { Route as DashboardAdminChangelogRouteImport } from './routes/_dashboard/admin/changelog'
import { Route as DashboardAdminAlertsRouteImport } from './routes/_dashboard/admin/alerts'
import { Route as DashboardAdminAgenciesRouteImport } from './routes/_dashboard/admin/agencies'
import { Route as DashboardSimulatorsIdIndexRouteImport } from './routes/_dashboard/simulators/$id/index'
import { Route as DashboardAdminSimulatorsIndexRouteImport } from './routes/_dashboard/admin/simulators/index'
import { Route as DashboardAdminReferencesIndexRouteImport } from './routes/_dashboard/admin/references/index'
import { Route as DashboardSimulatorsIdSimulateRouteImport } from './routes/_dashboard/simulators/$id/simulate'
import { Route as DashboardAdminSimulatorsIdRouteImport } from './routes/_dashboard/admin/simulators/$id'
import { Route as DashboardAdminReferencesIdRouteImport } from './routes/_dashboard/admin/references/$id'
import { Route as DashboardAdminSimulatorsIdTemplatesNewRouteImport } from './routes/_dashboard/admin/simulators/$id.templates.new'
import { Route as DashboardAdminSimulatorsIdTemplatesTemplateIdRouteImport } from './routes/_dashboard/admin/simulators/$id.templates.$templateId'

const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardUsersRoute = DashboardUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSimulationsRoute = DashboardSimulationsRouteImport.update({
  id: '/simulations',
  path: '/simulations',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPricingPolicyRoute = DashboardPricingPolicyRouteImport.update({
  id: '/pricing-policy',
  path: '/pricing-policy',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardHistoryRoute = DashboardHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => DashboardRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRoute,
} as any)
const DashboardSimulatorsIndexRoute =
  DashboardSimulatorsIndexRouteImport.update({
    id: '/simulators/',
    path: '/simulators/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardProposalsIndexRoute = DashboardProposalsIndexRouteImport.update({
  id: '/proposals/',
  path: '/proposals/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProposalsIdRoute = DashboardProposalsIdRouteImport.update({
  id: '/proposals/$id',
  path: '/proposals/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminUtilitiesRoute = DashboardAdminUtilitiesRouteImport.update({
  id: '/admin/utilities',
  path: '/admin/utilities',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminUserActivityRoute =
  DashboardAdminUserActivityRouteImport.update({
    id: '/admin/user-activity',
    path: '/admin/user-activity',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminSimulationsRoute =
  DashboardAdminSimulationsRouteImport.update({
    id: '/admin/simulations',
    path: '/admin/simulations',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminSimulationEventsRoute =
  DashboardAdminSimulationEventsRouteImport.update({
    id: '/admin/simulation-events',
    path: '/admin/simulation-events',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminProposalsRoute = DashboardAdminProposalsRouteImport.update({
  id: '/admin/proposals',
  path: '/admin/proposals',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminPricingPolicyRoute =
  DashboardAdminPricingPolicyRouteImport.update({
    id: '/admin/pricing-policy',
    path: '/admin/pricing-policy',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminModelsRoute = DashboardAdminModelsRouteImport.update({
  id: '/admin/models',
  path: '/admin/models',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminGroupsRoute = DashboardAdminGroupsRouteImport.update({
  id: '/admin/groups',
  path: '/admin/groups',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminDocumentationRoute =
  DashboardAdminDocumentationRouteImport.update({
    id: '/admin/documentation',
    path: '/admin/documentation',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminChangelogRoute = DashboardAdminChangelogRouteImport.update({
  id: '/admin/changelog',
  path: '/admin/changelog',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminAlertsRoute = DashboardAdminAlertsRouteImport.update({
  id: '/admin/alerts',
  path: '/admin/alerts',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAdminAgenciesRoute = DashboardAdminAgenciesRouteImport.update({
  id: '/admin/agencies',
  path: '/admin/agencies',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSimulatorsIdIndexRoute =
  DashboardSimulatorsIdIndexRouteImport.update({
    id: '/simulators/$id/',
    path: '/simulators/$id/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminSimulatorsIndexRoute =
  DashboardAdminSimulatorsIndexRouteImport.update({
    id: '/admin/simulators/',
    path: '/admin/simulators/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminReferencesIndexRoute =
  DashboardAdminReferencesIndexRouteImport.update({
    id: '/admin/references/',
    path: '/admin/references/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSimulatorsIdSimulateRoute =
  DashboardSimulatorsIdSimulateRouteImport.update({
    id: '/simulators/$id/simulate',
    path: '/simulators/$id/simulate',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminSimulatorsIdRoute =
  DashboardAdminSimulatorsIdRouteImport.update({
    id: '/admin/simulators/$id',
    path: '/admin/simulators/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminReferencesIdRoute =
  DashboardAdminReferencesIdRouteImport.update({
    id: '/admin/references/$id',
    path: '/admin/references/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminSimulatorsIdTemplatesNewRoute =
  DashboardAdminSimulatorsIdTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => DashboardAdminSimulatorsIdRoute,
  } as any)
const DashboardAdminSimulatorsIdTemplatesTemplateIdRoute =
  DashboardAdminSimulatorsIdTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => DashboardAdminSimulatorsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof DashboardIndexRoute
  '/callback': typeof AuthCallbackRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/history': typeof DashboardHistoryRoute
  '/pricing-policy': typeof DashboardPricingPolicyRoute
  '/settings': typeof DashboardSettingsRoute
  '/simulations': typeof DashboardSimulationsRoute
  '/users': typeof DashboardUsersRoute
  '/admin/agencies': typeof DashboardAdminAgenciesRoute
  '/admin/alerts': typeof DashboardAdminAlertsRoute
  '/admin/changelog': typeof DashboardAdminChangelogRoute
  '/admin/documentation': typeof DashboardAdminDocumentationRoute
  '/admin/groups': typeof DashboardAdminGroupsRoute
  '/admin/models': typeof DashboardAdminModelsRoute
  '/admin/pricing-policy': typeof DashboardAdminPricingPolicyRoute
  '/admin/proposals': typeof DashboardAdminProposalsRoute
  '/admin/simulation-events': typeof DashboardAdminSimulationEventsRoute
  '/admin/simulations': typeof DashboardAdminSimulationsRoute
  '/admin/user-activity': typeof DashboardAdminUserActivityRoute
  '/admin/utilities': typeof DashboardAdminUtilitiesRoute
  '/proposals/$id': typeof DashboardProposalsIdRoute
  '/proposals/': typeof DashboardProposalsIndexRoute
  '/simulators/': typeof DashboardSimulatorsIndexRoute
  '/admin/references/$id': typeof DashboardAdminReferencesIdRoute
  '/admin/simulators/$id': typeof DashboardAdminSimulatorsIdRouteWithChildren
  '/simulators/$id/simulate': typeof DashboardSimulatorsIdSimulateRoute
  '/admin/references/': typeof DashboardAdminReferencesIndexRoute
  '/admin/simulators/': typeof DashboardAdminSimulatorsIndexRoute
  '/simulators/$id/': typeof DashboardSimulatorsIdIndexRoute
  '/admin/simulators/$id/templates/$templateId': typeof DashboardAdminSimulatorsIdTemplatesTemplateIdRoute
  '/admin/simulators/$id/templates/new': typeof DashboardAdminSimulatorsIdTemplatesNewRoute
}
export interface FileRoutesByTo {
  '/': typeof DashboardIndexRoute
  '/callback': typeof AuthCallbackRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/history': typeof DashboardHistoryRoute
  '/pricing-policy': typeof DashboardPricingPolicyRoute
  '/settings': typeof DashboardSettingsRoute
  '/simulations': typeof DashboardSimulationsRoute
  '/users': typeof DashboardUsersRoute
  '/admin/agencies': typeof DashboardAdminAgenciesRoute
  '/admin/alerts': typeof DashboardAdminAlertsRoute
  '/admin/changelog': typeof DashboardAdminChangelogRoute
  '/admin/documentation': typeof DashboardAdminDocumentationRoute
  '/admin/groups': typeof DashboardAdminGroupsRoute
  '/admin/models': typeof DashboardAdminModelsRoute
  '/admin/pricing-policy': typeof DashboardAdminPricingPolicyRoute
  '/admin/proposals': typeof DashboardAdminProposalsRoute
  '/admin/simulation-events': typeof DashboardAdminSimulationEventsRoute
  '/admin/simulations': typeof DashboardAdminSimulationsRoute
  '/admin/user-activity': typeof DashboardAdminUserActivityRoute
  '/admin/utilities': typeof DashboardAdminUtilitiesRoute
  '/proposals/$id': typeof DashboardProposalsIdRoute
  '/proposals': typeof DashboardProposalsIndexRoute
  '/simulators': typeof DashboardSimulatorsIndexRoute
  '/admin/references/$id': typeof DashboardAdminReferencesIdRoute
  '/admin/simulators/$id': typeof DashboardAdminSimulatorsIdRouteWithChildren
  '/simulators/$id/simulate': typeof DashboardSimulatorsIdSimulateRoute
  '/admin/references': typeof DashboardAdminReferencesIndexRoute
  '/admin/simulators': typeof DashboardAdminSimulatorsIndexRoute
  '/simulators/$id': typeof DashboardSimulatorsIdIndexRoute
  '/admin/simulators/$id/templates/$templateId': typeof DashboardAdminSimulatorsIdTemplatesTemplateIdRoute
  '/admin/simulators/$id/templates/new': typeof DashboardAdminSimulatorsIdTemplatesNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_auth/callback': typeof AuthCallbackRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_dashboard/history': typeof DashboardHistoryRoute
  '/_dashboard/pricing-policy': typeof DashboardPricingPolicyRoute
  '/_dashboard/settings': typeof DashboardSettingsRoute
  '/_dashboard/simulations': typeof DashboardSimulationsRoute
  '/_dashboard/users': typeof DashboardUsersRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/admin/agencies': typeof DashboardAdminAgenciesRoute
  '/_dashboard/admin/alerts': typeof DashboardAdminAlertsRoute
  '/_dashboard/admin/changelog': typeof DashboardAdminChangelogRoute
  '/_dashboard/admin/documentation': typeof DashboardAdminDocumentationRoute
  '/_dashboard/admin/groups': typeof DashboardAdminGroupsRoute
  '/_dashboard/admin/models': typeof DashboardAdminModelsRoute
  '/_dashboard/admin/pricing-policy': typeof DashboardAdminPricingPolicyRoute
  '/_dashboard/admin/proposals': typeof DashboardAdminProposalsRoute
  '/_dashboard/admin/simulation-events': typeof DashboardAdminSimulationEventsRoute
  '/_dashboard/admin/simulations': typeof DashboardAdminSimulationsRoute
  '/_dashboard/admin/user-activity': typeof DashboardAdminUserActivityRoute
  '/_dashboard/admin/utilities': typeof DashboardAdminUtilitiesRoute
  '/_dashboard/proposals/$id': typeof DashboardProposalsIdRoute
  '/_dashboard/proposals/': typeof DashboardProposalsIndexRoute
  '/_dashboard/simulators/': typeof DashboardSimulatorsIndexRoute
  '/_dashboard/admin/references/$id': typeof DashboardAdminReferencesIdRoute
  '/_dashboard/admin/simulators/$id': typeof DashboardAdminSimulatorsIdRouteWithChildren
  '/_dashboard/simulators/$id/simulate': typeof DashboardSimulatorsIdSimulateRoute
  '/_dashboard/admin/references/': typeof DashboardAdminReferencesIndexRoute
  '/_dashboard/admin/simulators/': typeof DashboardAdminSimulatorsIndexRoute
  '/_dashboard/simulators/$id/': typeof DashboardSimulatorsIdIndexRoute
  '/_dashboard/admin/simulators/$id/templates/$templateId': typeof DashboardAdminSimulatorsIdTemplatesTemplateIdRoute
  '/_dashboard/admin/simulators/$id/templates/new': typeof DashboardAdminSimulatorsIdTemplatesNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/history'
    | '/pricing-policy'
    | '/settings'
    | '/simulations'
    | '/users'
    | '/admin/agencies'
    | '/admin/alerts'
    | '/admin/changelog'
    | '/admin/documentation'
    | '/admin/groups'
    | '/admin/models'
    | '/admin/pricing-policy'
    | '/admin/proposals'
    | '/admin/simulation-events'
    | '/admin/simulations'
    | '/admin/user-activity'
    | '/admin/utilities'
    | '/proposals/$id'
    | '/proposals/'
    | '/simulators/'
    | '/admin/references/$id'
    | '/admin/simulators/$id'
    | '/simulators/$id/simulate'
    | '/admin/references/'
    | '/admin/simulators/'
    | '/simulators/$id/'
    | '/admin/simulators/$id/templates/$templateId'
    | '/admin/simulators/$id/templates/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/history'
    | '/pricing-policy'
    | '/settings'
    | '/simulations'
    | '/users'
    | '/admin/agencies'
    | '/admin/alerts'
    | '/admin/changelog'
    | '/admin/documentation'
    | '/admin/groups'
    | '/admin/models'
    | '/admin/pricing-policy'
    | '/admin/proposals'
    | '/admin/simulation-events'
    | '/admin/simulations'
    | '/admin/user-activity'
    | '/admin/utilities'
    | '/proposals/$id'
    | '/proposals'
    | '/simulators'
    | '/admin/references/$id'
    | '/admin/simulators/$id'
    | '/simulators/$id/simulate'
    | '/admin/references'
    | '/admin/simulators'
    | '/simulators/$id'
    | '/admin/simulators/$id/templates/$templateId'
    | '/admin/simulators/$id/templates/new'
  id:
    | '__root__'
    | '/_auth'
    | '/_dashboard'
    | '/_auth/callback'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_dashboard/history'
    | '/_dashboard/pricing-policy'
    | '/_dashboard/settings'
    | '/_dashboard/simulations'
    | '/_dashboard/users'
    | '/_dashboard/'
    | '/_dashboard/admin/agencies'
    | '/_dashboard/admin/alerts'
    | '/_dashboard/admin/changelog'
    | '/_dashboard/admin/documentation'
    | '/_dashboard/admin/groups'
    | '/_dashboard/admin/models'
    | '/_dashboard/admin/pricing-policy'
    | '/_dashboard/admin/proposals'
    | '/_dashboard/admin/simulation-events'
    | '/_dashboard/admin/simulations'
    | '/_dashboard/admin/user-activity'
    | '/_dashboard/admin/utilities'
    | '/_dashboard/proposals/$id'
    | '/_dashboard/proposals/'
    | '/_dashboard/simulators/'
    | '/_dashboard/admin/references/$id'
    | '/_dashboard/admin/simulators/$id'
    | '/_dashboard/simulators/$id/simulate'
    | '/_dashboard/admin/references/'
    | '/_dashboard/admin/simulators/'
    | '/_dashboard/simulators/$id/'
    | '/_dashboard/admin/simulators/$id/templates/$templateId'
    | '/_dashboard/admin/simulators/$id/templates/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/users': {
      id: '/_dashboard/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof DashboardUsersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/simulations': {
      id: '/_dashboard/simulations'
      path: '/simulations'
      fullPath: '/simulations'
      preLoaderRoute: typeof DashboardSimulationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/pricing-policy': {
      id: '/_dashboard/pricing-policy'
      path: '/pricing-policy'
      fullPath: '/pricing-policy'
      preLoaderRoute: typeof DashboardPricingPolicyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/history': {
      id: '/_dashboard/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof DashboardHistoryRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/callback': {
      id: '/_auth/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_dashboard/simulators/': {
      id: '/_dashboard/simulators/'
      path: '/simulators'
      fullPath: '/simulators/'
      preLoaderRoute: typeof DashboardSimulatorsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/proposals/': {
      id: '/_dashboard/proposals/'
      path: '/proposals'
      fullPath: '/proposals/'
      preLoaderRoute: typeof DashboardProposalsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/proposals/$id': {
      id: '/_dashboard/proposals/$id'
      path: '/proposals/$id'
      fullPath: '/proposals/$id'
      preLoaderRoute: typeof DashboardProposalsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/utilities': {
      id: '/_dashboard/admin/utilities'
      path: '/admin/utilities'
      fullPath: '/admin/utilities'
      preLoaderRoute: typeof DashboardAdminUtilitiesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/user-activity': {
      id: '/_dashboard/admin/user-activity'
      path: '/admin/user-activity'
      fullPath: '/admin/user-activity'
      preLoaderRoute: typeof DashboardAdminUserActivityRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/simulations': {
      id: '/_dashboard/admin/simulations'
      path: '/admin/simulations'
      fullPath: '/admin/simulations'
      preLoaderRoute: typeof DashboardAdminSimulationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/simulation-events': {
      id: '/_dashboard/admin/simulation-events'
      path: '/admin/simulation-events'
      fullPath: '/admin/simulation-events'
      preLoaderRoute: typeof DashboardAdminSimulationEventsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/proposals': {
      id: '/_dashboard/admin/proposals'
      path: '/admin/proposals'
      fullPath: '/admin/proposals'
      preLoaderRoute: typeof DashboardAdminProposalsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/pricing-policy': {
      id: '/_dashboard/admin/pricing-policy'
      path: '/admin/pricing-policy'
      fullPath: '/admin/pricing-policy'
      preLoaderRoute: typeof DashboardAdminPricingPolicyRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/models': {
      id: '/_dashboard/admin/models'
      path: '/admin/models'
      fullPath: '/admin/models'
      preLoaderRoute: typeof DashboardAdminModelsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/groups': {
      id: '/_dashboard/admin/groups'
      path: '/admin/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof DashboardAdminGroupsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/documentation': {
      id: '/_dashboard/admin/documentation'
      path: '/admin/documentation'
      fullPath: '/admin/documentation'
      preLoaderRoute: typeof DashboardAdminDocumentationRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/changelog': {
      id: '/_dashboard/admin/changelog'
      path: '/admin/changelog'
      fullPath: '/admin/changelog'
      preLoaderRoute: typeof DashboardAdminChangelogRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/alerts': {
      id: '/_dashboard/admin/alerts'
      path: '/admin/alerts'
      fullPath: '/admin/alerts'
      preLoaderRoute: typeof DashboardAdminAlertsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/agencies': {
      id: '/_dashboard/admin/agencies'
      path: '/admin/agencies'
      fullPath: '/admin/agencies'
      preLoaderRoute: typeof DashboardAdminAgenciesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/simulators/$id/': {
      id: '/_dashboard/simulators/$id/'
      path: '/simulators/$id'
      fullPath: '/simulators/$id/'
      preLoaderRoute: typeof DashboardSimulatorsIdIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/simulators/': {
      id: '/_dashboard/admin/simulators/'
      path: '/admin/simulators'
      fullPath: '/admin/simulators/'
      preLoaderRoute: typeof DashboardAdminSimulatorsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/references/': {
      id: '/_dashboard/admin/references/'
      path: '/admin/references'
      fullPath: '/admin/references/'
      preLoaderRoute: typeof DashboardAdminReferencesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/simulators/$id/simulate': {
      id: '/_dashboard/simulators/$id/simulate'
      path: '/simulators/$id/simulate'
      fullPath: '/simulators/$id/simulate'
      preLoaderRoute: typeof DashboardSimulatorsIdSimulateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/simulators/$id': {
      id: '/_dashboard/admin/simulators/$id'
      path: '/admin/simulators/$id'
      fullPath: '/admin/simulators/$id'
      preLoaderRoute: typeof DashboardAdminSimulatorsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/references/$id': {
      id: '/_dashboard/admin/references/$id'
      path: '/admin/references/$id'
      fullPath: '/admin/references/$id'
      preLoaderRoute: typeof DashboardAdminReferencesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/simulators/$id/templates/new': {
      id: '/_dashboard/admin/simulators/$id/templates/new'
      path: '/templates/new'
      fullPath: '/admin/simulators/$id/templates/new'
      preLoaderRoute: typeof DashboardAdminSimulatorsIdTemplatesNewRouteImport
      parentRoute: typeof DashboardAdminSimulatorsIdRoute
    }
    '/_dashboard/admin/simulators/$id/templates/$templateId': {
      id: '/_dashboard/admin/simulators/$id/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/admin/simulators/$id/templates/$templateId'
      preLoaderRoute: typeof DashboardAdminSimulatorsIdTemplatesTemplateIdRouteImport
      parentRoute: typeof DashboardAdminSimulatorsIdRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardAdminSimulatorsIdRouteChildren {
  DashboardAdminSimulatorsIdTemplatesTemplateIdRoute: typeof DashboardAdminSimulatorsIdTemplatesTemplateIdRoute
  DashboardAdminSimulatorsIdTemplatesNewRoute: typeof DashboardAdminSimulatorsIdTemplatesNewRoute
}

const DashboardAdminSimulatorsIdRouteChildren: DashboardAdminSimulatorsIdRouteChildren =
  {
    DashboardAdminSimulatorsIdTemplatesTemplateIdRoute:
      DashboardAdminSimulatorsIdTemplatesTemplateIdRoute,
    DashboardAdminSimulatorsIdTemplatesNewRoute:
      DashboardAdminSimulatorsIdTemplatesNewRoute,
  }

const DashboardAdminSimulatorsIdRouteWithChildren =
  DashboardAdminSimulatorsIdRoute._addFileChildren(
    DashboardAdminSimulatorsIdRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardHistoryRoute: typeof DashboardHistoryRoute
  DashboardPricingPolicyRoute: typeof DashboardPricingPolicyRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardSimulationsRoute: typeof DashboardSimulationsRoute
  DashboardUsersRoute: typeof DashboardUsersRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAdminAgenciesRoute: typeof DashboardAdminAgenciesRoute
  DashboardAdminAlertsRoute: typeof DashboardAdminAlertsRoute
  DashboardAdminChangelogRoute: typeof DashboardAdminChangelogRoute
  DashboardAdminDocumentationRoute: typeof DashboardAdminDocumentationRoute
  DashboardAdminGroupsRoute: typeof DashboardAdminGroupsRoute
  DashboardAdminModelsRoute: typeof DashboardAdminModelsRoute
  DashboardAdminPricingPolicyRoute: typeof DashboardAdminPricingPolicyRoute
  DashboardAdminProposalsRoute: typeof DashboardAdminProposalsRoute
  DashboardAdminSimulationEventsRoute: typeof DashboardAdminSimulationEventsRoute
  DashboardAdminSimulationsRoute: typeof DashboardAdminSimulationsRoute
  DashboardAdminUserActivityRoute: typeof DashboardAdminUserActivityRoute
  DashboardAdminUtilitiesRoute: typeof DashboardAdminUtilitiesRoute
  DashboardProposalsIdRoute: typeof DashboardProposalsIdRoute
  DashboardProposalsIndexRoute: typeof DashboardProposalsIndexRoute
  DashboardSimulatorsIndexRoute: typeof DashboardSimulatorsIndexRoute
  DashboardAdminReferencesIdRoute: typeof DashboardAdminReferencesIdRoute
  DashboardAdminSimulatorsIdRoute: typeof DashboardAdminSimulatorsIdRouteWithChildren
  DashboardSimulatorsIdSimulateRoute: typeof DashboardSimulatorsIdSimulateRoute
  DashboardAdminReferencesIndexRoute: typeof DashboardAdminReferencesIndexRoute
  DashboardAdminSimulatorsIndexRoute: typeof DashboardAdminSimulatorsIndexRoute
  DashboardSimulatorsIdIndexRoute: typeof DashboardSimulatorsIdIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardHistoryRoute: DashboardHistoryRoute,
  DashboardPricingPolicyRoute: DashboardPricingPolicyRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardSimulationsRoute: DashboardSimulationsRoute,
  DashboardUsersRoute: DashboardUsersRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAdminAgenciesRoute: DashboardAdminAgenciesRoute,
  DashboardAdminAlertsRoute: DashboardAdminAlertsRoute,
  DashboardAdminChangelogRoute: DashboardAdminChangelogRoute,
  DashboardAdminDocumentationRoute: DashboardAdminDocumentationRoute,
  DashboardAdminGroupsRoute: DashboardAdminGroupsRoute,
  DashboardAdminModelsRoute: DashboardAdminModelsRoute,
  DashboardAdminPricingPolicyRoute: DashboardAdminPricingPolicyRoute,
  DashboardAdminProposalsRoute: DashboardAdminProposalsRoute,
  DashboardAdminSimulationEventsRoute: DashboardAdminSimulationEventsRoute,
  DashboardAdminSimulationsRoute: DashboardAdminSimulationsRoute,
  DashboardAdminUserActivityRoute: DashboardAdminUserActivityRoute,
  DashboardAdminUtilitiesRoute: DashboardAdminUtilitiesRoute,
  DashboardProposalsIdRoute: DashboardProposalsIdRoute,
  DashboardProposalsIndexRoute: DashboardProposalsIndexRoute,
  DashboardSimulatorsIndexRoute: DashboardSimulatorsIndexRoute,
  DashboardAdminReferencesIdRoute: DashboardAdminReferencesIdRoute,
  DashboardAdminSimulatorsIdRoute: DashboardAdminSimulatorsIdRouteWithChildren,
  DashboardSimulatorsIdSimulateRoute: DashboardSimulatorsIdSimulateRoute,
  DashboardAdminReferencesIndexRoute: DashboardAdminReferencesIndexRoute,
  DashboardAdminSimulatorsIndexRoute: DashboardAdminSimulatorsIndexRoute,
  DashboardSimulatorsIdIndexRoute: DashboardSimulatorsIdIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
